let previous_cart_count = null;

function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => removeItem(data_line,0));
    });
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      if(cart_count>0){
        $('.cart-bubble').html(cart_count);
        $('.cart-bubble,.h_carturl').addClass('active');
        
        if (previous_cart_count !== null && previous_cart_count !== cart_count) {
          $('.activeshrink').addClass('active');
          $('.h_carturl').addClass('activeshrink');
          setTimeout(function(){
            $('.h_carturl').removeClass('activeshrink');                     
          }, 2000);
        }
        
        previous_cart_count = cart_count;
      }else{
        $('.cart-bubble').html('');
        $('.cart-bubble,.h_carturl').removeClass('active');   
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
$(document).on('click','.item-remove',function (e) {
  e.preventDefault();
  let data_line = $(this).data('line');
  console.log('data_line',data_line);
  removeItem(data_line,0);
});
$(document).on('click','.cart-drawer-close,.h_carturl,.mcarturl',function (e) {
  e.preventDefault();
  $('body').toggleClass('open-drawer');
  $('body').removeClass('menu-open');
});
$(document).on('click','.overlay-box',function (e) {
  $('body').removeClass('open-drawer');
});


  $(document).on('click', '.quick-variants .var', function () {
    var linee = $(this).data('id');
    addItemNeww(linee)
  });

  function addItemNeww(linee) {
    let data = {
     'items': [{
      'id': linee,
      'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
      })
      .then((response) => response.json())
      .then((data) => {
          load_cart();
        setTimeout(()=>{
            $('body').addClass('open-drawer')
        },900);
      })
      .catch((error) => {
          console.error('Error:', error);
    });
  }

  
  $(document).ready(function() {
    $('.mobile-quick-variants').on('click', '.mobvar', function() {
        $('.mobvar').removeClass('focus');
        $(this).addClass('focus');
        var newId = $(this).data('id');
        $('.add-to-cart .btn').attr('data-id', newId);
    });

    $('.add-to-cart').on('click', '.btn', function() {
        var linee = $(this).attr('data-id');
        addItemNewwMob(linee);
        $(this).attr('data-id', '');
    });
});

function addItemNewwMob(linee) {
  let data = {
      'items': [{
          'id': linee,
          'quantity': 1
      }]
  };
  fetch('/cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
      load_cart();
      setTimeout(() => {
          $('body').addClass('open-drawer');
      }, 900);
      
      $('.quick-pop-up .add-to-cart').addClass('successcart');
      setTimeout(function () {
          $('.quick-pop-up .add-to-cart').removeClass('successcart');
      }, 3000);
  })
  .catch((error) => {
      console.error('Error:', error);
  });
}